import CopyText from './CopyText'
export * from './types'

export { CopyText }
